export default __webpack_public_path__ + "static/media/Path3359.47a1f0c2.svg";